import React from 'react';
import styled, { css } from 'styled-components';
import { SwiperSlide } from 'swiper/react';

import { useMedia } from '@tager/web-core';

import StockCarCard from '@/components/StockCarCard';
import { useTypedSelector } from '@/store/store';
import { selectSimilarCarsData } from '@/store/reducers/detailed-car';
import { media } from '@/utils/mixin';
import {
  getCarBadges,
  getCarImages,
  getCarLink,
  getCarPrice,
  getCarStatus,
  getCarTags,
} from '@/modules/CarsStock/components/common.helpers';
import { usePhoneNumber } from '@/hooks/usePhoneNumber';
import {
  SliderWrapper,
  Header as SliderWrapperHeader,
} from '@/components/LandingWidgets/components/SliderWrapper';

function BaseSlider() {
  const isLaptopOnly = useMedia('(max-width: 1539px) and (min-width: 1260px)');
  const isTablet = useMedia('(max-width: 1259px)');
  const similarCars = useTypedSelector(selectSimilarCarsData);
  const phone = usePhoneNumber();

  if (!similarCars || !similarCars.length) {
    return null;
  }

  return (
    <Component>
      <TitleWrapper>
        <BaseSliderTitle>
          <Title>Вас заинтересует</Title>
        </BaseSliderTitle>
      </TitleWrapper>

      <SliderWrapper
        options={{
          spaceBetween: 20,
          withoutNavs: isTablet,
          withoutPagination: true,
        }}
      >
        {similarCars.map((item) => (
          <SwiperSlide key={item.id}>
            <StockCarCard
              images={getCarImages(item)}
              name={item.name}
              subName={item.complectation ?? ''}
              view="portrait"
              link={getCarLink('new', item.id)}
              price={getCarPrice(item, phone)}
              tags={getCarTags(item)}
              badgesList={getCarBadges(item)}
              totalImagesCount={item.imagesCount}
              carStatus={getCarStatus(item)}
              stockStatus={item.stockStatus ?? undefined}
              isMobile={isTablet}
              isLaptop={isLaptopOnly}
            />
          </SwiperSlide>
        ))}
      </SliderWrapper>
    </Component>
  );
}

export default BaseSlider;

const Component = styled.div`
  position: relative;
  margin-top: 75px;

  ${media.mobile(css`
    margin-top: 30px;
  `)}

  ${SliderWrapperHeader} {
    top: -75px;
  }

  .swiper-slide {
    max-width: 451px;
    height: auto;
    padding-bottom: 5px;

    @media (min-width: 1791px) and (max-width: 1822px) {
      max-width: 427px;
    }

    @media (min-width: 1640px) and (max-width: 1790px) {
      max-width: 403px;
    }

    @media (min-width: 1475px) and (max-width: 1639px) {
      max-width: 380px;
    }

    @media (min-width: 1357px) and (max-width: 1474px) {
      max-width: 324px;
    }

    @media (min-width: 1260px) and (max-width: 1356px) {
      max-width: 286px;
    }

    ${media.tablet(css`
      max-width: 340px;
    `)}
  }
`;

const TitleWrapper = styled.div`
  display: flex;
`;

const BaseSliderTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 35px;
`;

const Title = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${(props) => props.theme.black};

  ${media.laptopOnly(
    css`
      font-size: 24px;
    `
  )}

  ${media.mobile(
    css`
      font-size: 24px;
    `
  )}
`;
